/* SVARAA — Shoppable Reel
 * Videos autoplay via IntersectionObserver on all devices.
 * Clicking a card navigates directly to the linked product page.
 */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shouldSkipVideo() {
    if (prefersReduced) return true;
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    if (c.effectiveType && /(^|-)(slow-2g|2g)$/.test(c.effectiveType)) return true;
    return false;
  }

  function loadVideo(video) {
    if (video.__svaraaLoaded) return;
    video.__svaraaLoaded = true;
    try { video.load(); } catch (e) {}
    video.addEventListener('loadeddata', function () {
      video.setAttribute('data-ready', 'true');
    }, { once: true });
  }

  function playVideo(video) {
    var media = video.closest('.svaraa-reel-card__media');
    var p = video.play();
    if (p && typeof p.then === 'function') {
      p.then(function () {
        if (media) media.classList.add('is-playing');
      }).catch(function () {});
    } else {
      if (media) media.classList.add('is-playing');
    }
  }

  function pauseVideo(video) {
    var media = video.closest('.svaraa-reel-card__media');
    try {
      video.pause();
      video.currentTime = 0;
    } catch (e) {}
    if (media) media.classList.remove('is-playing');
  }

  /* ── Per-card intersection observer ──────────────────────────── */
  function bindIntersection(video) {
    if (!('IntersectionObserver' in window)) {
      loadVideo(video);
      playVideo(video);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(video);
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    }, { threshold: 0.5 });
    io.observe(video);
  }

  /* ── Desktop hover on top of intersection ─────────────────────── */
  function bindHover(video) {
    var card = video.closest('.svaraa-reel-card');
    if (!card) return;
    card.addEventListener('pointerenter', function () {
      loadVideo(video);
      playVideo(video);
    });
    card.addEventListener('pointerleave', function () {
      pauseVideo(video);
    });
    card.addEventListener('focusin', function () {
      loadVideo(video);
      playVideo(video);
    });
    card.addEventListener('focusout', function () {
      pauseVideo(video);
    });
  }

  /* ── Init videos ──────────────────────────────────────────────── */
  function initVideos(root) {
    if (shouldSkipVideo()) {
      (root || document).querySelectorAll('[data-svaraa-reel-video]').forEach(function (v) {
        v.remove();
      });
      return;
    }

    var isTouch = window.matchMedia('(hover: none)').matches;

    (root || document).querySelectorAll('[data-svaraa-reel-video]').forEach(function (video) {
      if (video.__svaraaBound) return;
      video.__svaraaBound = true;

      bindIntersection(video);
      if (!isTouch) bindHover(video);
    });
  }

  /* ── Slider arrow navigation ──────────────────────────────────── */
  function initSlider(section) {
    var track = section.querySelector('.svaraa-reel__track');
    var prevBtn = section.querySelector('.svaraa-reel__arrow--prev');
    var nextBtn = section.querySelector('.svaraa-reel__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = track.querySelector('.svaraa-reel-card');
      if (!card) return track.clientWidth * 0.8;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 20;
      return (card.offsetWidth + gap) * 2;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', track.scrollLeft >= maxScroll - 2 ? 'true' : 'false');
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateArrows).observe(track);
    }
  }

  /* ── Bootstrap ────────────────────────────────────────────────── */
  function init(root) {
    var sections = (root || document).querySelectorAll('.svaraa-reel');
    sections.forEach(function (section) {
      initSlider(section);
    });
    initVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
